import axiosClient from "./axiosClient";

async function login(bookingNumber: string, bookName: string, captchaData?: { captchaId: string, userAnswer: number }) {
  const bodyReq = {
    bookingNumber: bookingNumber,
    name: bookName,
    ...captchaData
  };
  try {
    const response = await axiosClient.post("/auth/login", bodyReq);

    if (response.status !== 200) {
      console.warn(`api call response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export async function confirmEMail(
  email: string,
  orgunit: string,
  orderId: string
) {
  const bodyReq = {
    email: email,
    orgunit: orgunit,
    orderId: orderId,
  };

  try {
    const response = await axiosClient.post("/auth/confirmEmail", bodyReq);

    if (response.status !== 200) {
      console.warn(`api call response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default login;
